import React from 'react'

export function PlayIconFilled(props) {
  return (
    <svg
      width='80'
      height='80'
      viewBox='0 0 80 80'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='1.25'
        y='1.25'
        width='77.5'
        height='77.5'
        rx='38.75'
        fill='#AC0AE8'
        stroke='white'
        strokeWidth='2.5'
      />
      <path
        d='M57.7451 37.2748L33.3725 23.6548C31.3645 22.5417 28.3872 23.6548 28.3872 26.3396V53.5796C28.3872 56.0678 31.1568 57.5739 33.3725 56.3298L57.7451 42.7097C59.8916 41.4656 59.8916 38.519 57.7451 37.2748Z'
        fill='white'
      />
    </svg>
  )
}
